import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Download } from "lucide-react";
import { accentFor } from "@/lib/accents";

export const ProductCard = ({ product, index = 0 }) => {
  const accent = accentFor(product.slug);
  return (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className="group"
    data-testid={`product-card-${product.slug}`}
  >
    <Link to={`/product/${product.slug}`} className="block">
      <div className="relative overflow-hidden border border-black/10 bg-muted">
        <div className="absolute inset-x-0 top-0 z-10 h-1.5 origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100" style={{ background: accent }} />
        <div className="absolute left-4 top-4 z-10 inline-flex items-center gap-1 bg-white/90 px-2.5 py-1 text-[10px] uppercase tracking-[0.15em] text-foreground">
          <Download className="h-3 w-3" /> Instant
        </div>
        <div className="aspect-[4/5] overflow-hidden">
          <img src={product.mockup_image} alt={product.title}
            className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" />
        </div>
        <div className="absolute bottom-3 right-3 z-10 w-16 overflow-hidden border-2 border-white shadow-xl transition-transform duration-500 group-hover:-translate-y-1 sm:w-[4.5rem]">
          <img src={`${process.env.REACT_APP_BACKEND_URL}/api/cover/${product.slug}`} alt={`${product.title} preview`}
            onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }}
            className="block w-full" />
        </div>
      </div>
      <div className="flex items-start justify-between pt-5">
        <div>
          <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
            <span className="inline-block h-2 w-2" style={{ background: accent }} /> {product.category}
          </p>
          <h3 className="mt-1 font-display text-xl tracking-tight">{product.title}</h3>
        </div>
        <ArrowUpRight className="mt-1 h-5 w-5 text-muted-foreground transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </div>
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-muted-foreground">{product.tagline}</p>
      <div className="mt-4 flex items-center justify-between border-t border-black/5 pt-4">
        <span className="font-display text-lg">${product.price?.toFixed(2)}</span>
        <span className="text-sm text-foreground underline underline-offset-4 group-hover:no-underline" style={{ textDecorationColor: accent }}>View Guide</span>
      </div>
    </Link>
  </motion.div>
  );
};
